import { render } from "./BookLendRanking.vue?vue&type=template&id=87e3a1c0"
import script from "./BookLendRanking.vue?vue&type=script&lang=js"
export * from "./BookLendRanking.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__